import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { commonStrigns, assessmentString, stringFiles } from "res/strings";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import { Box } from "styled-components/box";
import { useDispatch } from "react-redux";
import { setExamCounter, setIsUploadingFile, setOnlineExam, setShowNextQuestion } from "redux/onlineExam/onlineExam.actions";

function PlanCard({
  t,
  title,
  description,
  subject,
  duration,
  courseName,
  startAtPersian,
  endAtPersian,
  isJoinToExam,
  courses,
  id
}) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const courseNames = courses.map(course => course.name)

  const routeName = router.pathname.search("onlineExam") === 1 ? "onlineExam" : "assignment"
  const routeID = router.pathname.search("onlineExam") === 1 ? "onlineExamID" : "assignmentID"


  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Body className="d-flex flex-column text-left">
          <p className="m-0">
            {t(assessmentString.assessmentStartQuestion)}
          </p>
          {/* <p className="m-0 text-danger text-left">
         {t(assessmentString.assessmentStartInfoQuestion)}
         </p> 
          <p className="m-0 text-warning text-left">
         {t(assessmentString.assessmentStartInfoTwoQuestion)}
         </p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
                router.push(`/${routeName}/[onlineExamID]`,`/${routeName}/${id}`)
            }}
          >
            {t(assessmentString.start)}
          </Button>

          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t(commonStrigns.cancel)}
          </Button>
        </Modal.Footer>
      </Modal>
      <Card className="my-2">
        <Card.Header className="d-flex text-primary">{title}</Card.Header>
        <Card.Body>
          {duration && <RowItem value={`${duration} دقیقه`} label={t(assessmentString.duration)} />}
          <RowItem value={endAtPersian} label={t(assessmentString.endAt)} />
          <RowItem
            value={subject}
            label={t(assessmentString.subject)}
          />
          <RowItem
            value={courses.length > 0 && courseNames.toString()}
            label={t(assessmentString.courseName)}
          />
          {description && <RowItem
            value={description}
            label={t(assessmentString.description)}
          />}
          {isJoinToExam && <Box
            onClick={() => {
              dispatch(setOnlineExam(id))
              dispatch(setExamCounter(null))
              dispatch(setIsUploadingFile(false))
              dispatch(setShowNextQuestion(false))

              setShowModal(true)
            }}
            className="d-flex justify-content-end align-items-center"
          >
            <p className="text-success m-0 ">{t(assessmentString.start)}</p>
            <Box width="1em" className="text-success">
              {process.env.NEXT_PUBLIC_RTL ? (
                <BsArrowLeftShort />
              ) : (
                <BsArrowRightShort />
              )}
            </Box>
          </Box>}
        </Card.Body>
        <Card.Footer className="d-flex text-primary">
          {t(assessmentString.start)}: {startAtPersian}
        </Card.Footer>
      </Card>
    </>
  );
}

const RowItem = ({ label, value }) => {
  return (
    <Row>
      <Col className="d-flex p-0 m-0 text-left" xs={4}>
        {label && <p>{label}</p>}
      </Col>
      <Col className="d-flex p-0 m-0" xs={8}>
        <p className="text-left text-primary">{value}</p>
      </Col>
    </Row>
  );
};

export default withTranslation(stringFiles.common)(PlanCard);
